export const screenWidths = {
  xl: 1920,
  lg: 1280,
  md: 1024,
};
